import { motion } from "framer-motion";
import { SITE } from "@/data/site";
import BookingButtons from "@/components/site/BookingButtons";
import { MaskLines } from "@/components/site/Reveal";

export default function BookingCTA() {
  return (
    <section data-testid="booking-cta" className="relative flex min-h-[68vh] items-center overflow-hidden bg-forest text-ivory">
      <img src={SITE.heroImage} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-t from-forest via-forest/80 to-forest/70" />

      <div className="relative z-10 mx-auto w-full max-w-[1400px] px-5 py-16 text-center md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mb-6 text-xs uppercase tracking-widest-2 text-gold md:text-sm"
        >
          Your Escape Begins Here
        </motion.p>

        <h2 className="mx-auto max-w-4xl font-display text-5xl font-bold leading-[0.98] tracking-tight sm:text-6xl md:text-7xl lg:text-8xl">
          <MaskLines lines={["Book your stay", "in the mist"]} />
        </h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mx-auto mt-7 max-w-xl text-ivory/80"
        >
          Message us on WhatsApp or call directly &mdash; we&apos;ll craft the perfect Malnad getaway for you.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="mt-10 flex justify-center"
        >
          <BookingButtons variant="dark" size="lg" />
        </motion.div>

        <p className="mt-10 text-sm text-ivory/50">{SITE.address}</p>
      </div>
    </section>
  );
}
